import Vue from 'vue';
import VueI18n from 'vue-i18n';
import dayjs from 'dayjs';
import 'dayjs/locale/de'
import {messages} from '../lang/messages';
const localizedFormat = require('dayjs/plugin/localizedFormat');
const relativeTime = require('dayjs/plugin/relativeTime')
const isYesterday = require('dayjs/plugin/isYesterday')

Vue.use(VueI18n);

const LOCALE_GERMAN = 'de';

let locale = LOCALE_GERMAN;

const vuei18n = new VueI18n({
    locale: locale,
    fallbackLocale: LOCALE_GERMAN,
    messages: messages
});

dayjs.extend(localizedFormat);
dayjs.locale(locale);
dayjs.extend(relativeTime);
dayjs.extend(isYesterday);

export { vuei18n, locale }
